import React, { forwardRef } from 'react';
import '../../styles/vendorregistration.css';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
const AddressPage = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const {
    formData,
    updateFormData,
    errors,
    handleFieldFocus,
    registerFieldRef,
    statesByCountry
  } = props;

  const handleChange = (e) => {
    const { id, value } = e.target;
    updateFormData('address', id, value);
  };

  return (
    <div ref={ref} className="form-section">
      <h2 className="page-title">{t('vendorRegistration.headers.step4')}</h2>
      <p className="page-description">{t('vendorRegistration.subdescriptions.step4')}</p>


      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="street">{t('vendorRegistration.formLabels.street')}<span> *</span></label>
          <div className="input-container">
            <input type="text"
              id="street"
              placeholder={t('vendorRegistration.formLabels.street')}
              maxLength="50"
              value={formData.address.street || ''}
              onChange={(e) => { handleFieldFocus('address', 'street'); handleChange(e); }}
              ref={(el) => registerFieldRef('street', el)}
              className={errors.address?.street ? 'error' : ''}
            />
            {errors.address?.street && (
              <div className="error-message">{t(`vendorRegistration.errors.${errors.address?.street}`)}</div>
            )}
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="city">{t('vendorRegistration.formLabels.city')}<span> *</span></label>
          <div className="input-container">
            <input type="text"
              id="city"
              maxLength="50"
              placeholder={t('vendorRegistration.formLabels.city')}
              value={formData.address.city || ''}
              onChange={(e) => { handleFieldFocus('address', 'city'); handleChange(e); }}
              ref={(el) => registerFieldRef('city', el)}
              className={errors.address?.city ? 'error' : ''}
            />
            {errors.address?.city && (
              <div className="error-message">{t(`vendorRegistration.errors.${errors.address?.city}`)}</div>
            )}
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="country">{t('vendorRegistration.formLabels.country')}<span> *</span></label>
          <div className="input-container">
            <input type="text"
              id="country"
              value={formData.registrationDetails.phone_country.name}
              disabled
              placeholder={t('vendorRegistration.formLabels.country')}
              // value={formData.address.country || ''}
              // onChange={handleChange}
              // onFocus={() => handleFieldFocus('address', 'country')}
              ref={(el) => registerFieldRef('country', el)}
              className={errors.address?.country ? 'error' : ''}
            />
            {errors.address?.country && (
              <div className="error-message">{t(`vendorRegistration.errors.${errors.address?.country}`)}</div>
            )}
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="region">{t('vendorRegistration.formLabels.region')}<span> *</span></label>
          <div className='input-container'>
            <Select
              iid="region"
              value={
                statesByCountry[formData.registrationDetails.phone_country.code]?.find(
                  state => state.name === formData.address.region
                ) || null
              }
              ref={(el) => registerFieldRef('region', el)}
              className={`dropdown ${errors.address?.region ? 'error' : ''}`}
              onChange={(option) => { updateFormData('address', 'region', option?.name || ''); handleFieldFocus('address', 'region') }}
              options={statesByCountry[formData.registrationDetails.phone_country.code] || []}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.code}
              placeholder={t('vendorRegistration.common.selectOption')}
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  minHeight: '47px',
                  border: '1.5px solid #d1d5db54',
                  '&:hover': {
                    border: '1px solid #65c7c2 !important',
                  },
                  ...(state.isFocused && {
                    border: 'none !important',
                    boxShadow: 'none !important',
                  }),
                }),
                menu: (provided) => ({
                  ...provided,
                  minHeight: '200px',
                  maxHeight: 'fit-content',
                  overflowY: 'auto',
                  width: '100%',
                  minWidth: '100%',
                  zIndex: 100,
                  marginTop: '4px',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                  borderRadius: '4px',
                  border: '1px solid #e2e8f0',
                }),
                menuList: (provided) => ({
                  ...provided,
                  padding: '4px 0',
                }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isSelected ? '#65c7c2' : state.isFocused ? '#f0fdfa' : 'white',
                  color: state.isSelected ? 'white' : '#1f2937',
                  padding: '8px 12px',
                  '&:active': {
                    backgroundColor: '#ccfbf1',
                  },
                }),
              }}
            />
          </div>
          {errors.address?.region && (
            <div className="error-message">{t(`vendorRegistration.errors.${errors.address?.region}`)}</div>
          )}
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="zipcode">{t('vendorRegistration.formLabels.zip')}<span> *</span></label>
        <div className="input-container">
          <input type="text"
            id="zip"
            maxLength="10"
            placeholder={t('vendorRegistration.formLabels.zip')}
            value={formData.address.zip || ''}
            onChange={(e) => { handleFieldFocus('address', 'zip'); handleChange(e); }}
            ref={(el) => registerFieldRef('zip', el)}
            className={errors.address?.zip ? 'error' : ''}
          />
          {errors.address?.zip && (
            <div className="error-message">{t(`vendorRegistration.errors.${errors.address?.zip}`)}</div>
          )}
        </div>
      </div>
    </div>
  );
});

export default AddressPage;